module.exports = __webpack_public_path__ + "img/dns-resolve.0e539017.png";